import { useTranslation } from "react-i18next";
import { mainWebsiteUrl } from "@/mocks/categories";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20wide%20elegant%20arrangement%20of%20premium%20accessories%20including%20a%20leather%20handbag%2C%20a%20folded%20silk%20scarf%2C%20a%20wristwatch%20and%20a%20pair%20of%20sunglasses%20on%20a%20soft%20blush%20cream%20background%2C%20warm%20studio%20lighting%2C%20refined%20editorial%20product%20photography%2C%20gentle%20shadows%20and%20a%20luxurious%20airy%20composition&width=1600&height=700&seq=cta-usfans-1&orientation=landscape&nocache=true"
        alt="USFans latest resources"
        title="USFans Spreadsheet resources"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/45" />

      <div className="relative z-10 mx-auto max-w-3xl px-4 md:px-6 py-16 md:py-24 text-center">
        <h2 className="font-heading text-2xl font-bold text-white md:text-4xl">
          {t("cta.title")}
        </h2>
        <p className="mt-4 text-sm text-white/85 md:text-base">{t("cta.body")}</p>
        <a
          href={mainWebsiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-8 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
        >
          <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-base" />
          {t("cta.button")}
        </a>
      </div>
    </section>
  );
}